import { FC } from "react";
import { CountryOnboardingRequestDto } from "../../../api/Api";
import { OnboardingRequestsAdminGrid } from "../../../components/onboardingRequests/adminRequestsGrid";
import { OnboardingRequestBook } from "../../../components/onboardingRequests/types";
import { useCountryOnboardingRequests } from "./queries";
import { ReviewDialog } from "./reviewDialog";

const countryBook: OnboardingRequestBook<CountryOnboardingRequestDto> = {
  entityLabel: "Country",
  entityName: (row) => row.payload?.countryName ?? "",
  resultingEntityId: (row) => row.resultingCountryId,
  entityPath: (id) => `/countries/country/${id}`
};

export const CountryOnboardingRequestsAdmin: FC = () => (
  <OnboardingRequestsAdminGrid
    book={countryBook}
    useRequests={useCountryOnboardingRequests}
    renderReviewDialog={({ open, request, onClose }) => (
      <ReviewDialog open={open} request={request} onClose={onClose} />
    )}
  />
);
